import React, {Fragment, useState} from "react";
import Typography from "@material-ui/core/Typography";
import MeetingOpen from "./MeetingOpen";
import MeetingFinished from "./MeetingFinished";
import MeetingReady from "./MeetingReady";
import Question from "../question/Question";
import {getMessage} from "../../util";
import TableContainer from "@material-ui/core/TableContainer";
import {Paper, TableCell} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import config from "../../config.json";
import Container from "@material-ui/core/Container";
import VideoConference from "./VideoConferece";

const Meeting = (props) => {

    const meeting = props.meeting;
    const representative = props.representative;
    const messages = props.messages;
    const [question, setQuestion] = useState(null);

    const getState = (meeting) => {
        switch (meeting.state) {
            case 'open':
                return (<MeetingOpen user={representative} messages={messages} meeting={meeting}
                                     setQuestion={setQuestion}/>);
            case 'finished':
                return (<MeetingFinished user={representative} messages={messages} meeting={meeting}
                                         setQuestion={setQuestion}/>);
            default:
                return (<MeetingReady user={representative} messages={messages} meeting={meeting}
                                      setQuestion={setQuestion}/>);
        }
    }

    const number = {
        fontFamily: "Montserrat"
    };

    return (
        <Fragment>
            {
                (meeting && representative) ? (
                    <Fragment>

                        {question ? (
                            <Question messages={messages} question={question} meeting={meeting}
                                      setQuestion={setQuestion}
                                      user={props.user}/>
                        ) : (
                            getState(meeting)
                        )}

                        {meeting && representative.holders.length > 0 && (
                            <Container>
                                <br/>
                                <br/>
                                <Typography variant={"h6"}>
                                    {getMessage(meeting.meeting_type, 'holders', messages)}
                                </Typography>
                                <TableContainer component={Paper}>
                                    <Table aria-label="representados">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>{getMessage(meeting.meeting_type, 'search_id', messages)}</TableCell>
                                                <TableCell>{getMessage(meeting.meeting_type, 'search_name', messages)}</TableCell>
                                                <TableCell>{getMessage(meeting.meeting_type, 'shares', messages)}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {representative.holders.sort((a, b) => a.order - b.order).map(h => (
                                                <TableRow key={h.identity}>
                                                    <TableCell component="th" scope="row">
                                                        {h.identity}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        {h.name}
                                                    </TableCell>
                                                    <TableCell>
                                                        {Object.keys(h.shares).map(s => (
                                                            <Fragment key={s}>
                                <span>{h.shares[s].name}: <span
                                    style={number}>{h.shares[s].shares.toLocaleString(navigator.language, {
                                    maximumFractionDigits: config.precision
                                })}</span></span>
                                                                <br/>
                                                            </Fragment>
                                                        ))}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Container>
                        )}
                    </Fragment>
                ) : (
                        <Typography variant="h5" component="h2">
                            {getMessage('default', 'meeting_not_found', null)}
                        </Typography>
                    )
                }
        </Fragment>
    );
}

export default Meeting;